<template>
    <v-flex row wrap xs12 sm12 md12 lg12 ml-2 mr-2 >

        <v-flex xs12 sm12 md9 lg8 >
            <v-flex>
                [{{zoneName}}]
                <v-btn class="text-right regFRBtn" @click="linkGoogle">
                    Google行事曆<v-icon>mdi-calendar-month</v-icon>
                </v-btn>
            </v-flex>
            <v-container class="xs12 sm12 md8 lg8 row--dense">

                <v-row class="row--dense">
                    <v-col cols="12" sm="12" md="6">
                        <table style="width: 100%;height: auto" class="  elevation-1">
                            <thead class="clinicNoThead1">
                            <tr>
                                <th class="clinicNoTh1">病歷號碼</th>
                                <th class="clinicNoTh1">姓名</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template>
                                <tr >
                                    <td class="text-center clinicNoTd1">
                                        <v-flex class="clinicNoTdDiv1">
                                            {{chartNo}}
                                        </v-flex>
                                    </td>
                                    <td class="text-center clinicNoTd1">
                                        <v-flex class="clinicNoTdDiv1">
                                            {{ptName}}
                                        </v-flex>
                                    </td>
                                </tr>
                            </template>

                            </tbody>
                        </table>
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                        <table style="width: 100%" class="  elevation-1 xs12 sm12 md6 lg6">
                            <thead class="clinicNoThead1">
                            <tr>
                                <th class="clinicNoTh1">身分證號</th>
                                <th class="clinicNoTh1">生日</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template>
                                <tr >
                                    <td class="text-center clinicNoTd1">
                                        <!-- <v-flex class="clinicNoTdDiv1"> -->
                                            <!-- {{idNo}} -->
                                        <!-- </v-flex> -->
                                    </td>
                                    <td class="text-center clinicNoTd1">
                                        <v-flex class="clinicNoTdDiv1">
                                            {{birthDate}}
                                        </v-flex>
                                    </td>
                                </tr>
                            </template>

                            </tbody>
                        </table>
                    </v-col>

                </v-row>

                <v-row class="row--dense" cols="12" sm="12" md="6">
                    <v-col cols="12" sm="12" md="6">
                        <table style="width: 100%" class="elevation-1">
                            <thead class="clinicNoThead2" >
                            <tr>
                                <th ref="headerWidth" class="clinicNoTh2">看診日期</th>
                                <th class="clinicNoTh2">時段</th>
                            </tr>
                            </thead>
                            <tbody>
                            <template>
                                <tr >
                                    <td class="text-center clinicNoTd2" >
                                        <div class="clinicNoTdDiv2 dateBox" style="">
                                            <!-- {{viewDate}} &nbsp; {{ "星期" + week[new Date(this.$UtilityJs.transROC2YMDFormat(viewDate)).getDay()]  }} -->
                                            <!-- <div row > -->
                                               <!-- <span style="font-size: 2.5rem!important;"></span> -->
                                                <!-- <v-col xs="12" md="12" lg="12" style="padding:0"> -->
                                                    <span >{{ wordDate }} </span>
                                                <!-- </v-col> -->
                                                <!-- <v-col xs="0" md="0" lg="0" style="padding:0"> -->
                                                <!-- {{ wordDate }} <br>  -->
                                                <!-- </v-col> -->
                                                <span id="weekWord" >
                                                <!-- <v-col xs="12" md="12" lg="12" style="padding:0"> -->
                                                    {{ "星期" + week[new Date(this.$UtilityJs.transROC2YMDFormat(viewDate)).getDay()]  }}
                                                </span>
                                                <!-- </v-col> -->
                                            <!-- </div> -->
                                        </div>
                                    </td>
                                    <td class="text-center clinicNoTd2">
                                        <div class="clinicNoTdDiv2" >
                                            <!-- <span style="font-size: 2.5rem!important;"></span> -->
                                            <div >
                                            <v-flex class="align-center timeBox" style="">
                                                <!-- <span style="font-size: 2.5rem!important;"></span> -->
                                                <span>
                                                {{apn}}
                                                </span> 
                                            </v-flex>
                                            </div>
                                            <!-- <span style="font-size: 5rem!important;"></span> -->
                                        </div>
                                    </td>
                                </tr>


                            </template>

                            </tbody>
                        </table>
                    </v-col>

                    <v-col cols="12" sm="12" md="6">
                        <table style="width: 100%" class="elevation-1"  v-resize="resizeTable">
                            <thead class="clinicNoThead2">
                            <tr>
                                <th  colspan="2" class="clinicNoTh2">看診號碼</th>

                                <!--<th class="clinicNoTh2"></th>-->
                            </tr>
                            </thead>
                            <tbody>
                            <template>
                                <tr >
                                    <td colspan="2" class="text-center clinicNoTd2">
                                        <v-flex  class="clinicNoTdDiv2" style="height:85px;">
                                            <span style="font-size: 2.5rem!important;font-weight: bold">{{viewNo==undefined?0:viewNo}} </span>
                                            <span> {{fvRv}}</span>
                                        </v-flex>

                                    </td>
                                    <!--<td class="text-center ">-->
                                    <!--<v-flex class="clinicNoTdDiv2">-->
                                    <!--{{fvRv}}-->
                                    <!--<span style="font-size: 2.5rem!important;"></span>-->
                                    <!--</v-flex>-->
                                    <!--</td>-->
                                </tr>



                            </template>

                            </tbody>
                        </table>
                    </v-col>

                    <v-col cols="12" sm="12" md="12">
                        <table  style="width: 100%" class="elevation-1">
                            <tbody>
                            <template>
                                <tr class="clinicNoThead2 text-center">
                                    <td class="clinicNoTh2" :style="{width:$vuetify.breakpoint.smAndDown?'auto':theadWidth}">科別/診間</td>
                                    <td class="text-center clinicNoTd2">
                                        <v-flex class="clinicNoTdDiv2" v-html="$vuetify.breakpoint.smAndDown?clinicName+'<br/>'+divName:clinicName+' '+divName">
                                          
                                        </v-flex>
                                    </td>
                                </tr>
                                <tr class="clinicNoThead2 text-center">
                                    <td class="clinicNoTh2" style="border-top: 1px solid white;">看診醫師</td>
                                    <td class="text-center clinicNoTd2" style="background: white!important;">
                                        <v-flex class="clinicNoTdDiv2">
                                            {{doctorName}}
                                        </v-flex>
                                    </td>
                                </tr>


                            </template>

                            </tbody>
                        </table>
                    </v-col>

                </v-row>



            </v-container>





            <v-flex class=" xs12 sm12 md12 pl-1 ml-1">
                <p style="font-size: 1.2rem!important;color: red" v-html="regNote"></p>
                <v-btn class="text-right regFRBtn" @click="printResult">
                    列印<v-icon>mdi-printer</v-icon>
                </v-btn>

            </v-flex>
            <v-flex class=" xs12 sm12 md12 pl-1 ml-1">
                <span v-html="clinicNoteB" style="font-size: 1.2rem;color: blue;font-weight: bold"></span>
            </v-flex>

        </v-flex>

        <v-flex xs12 sm12 md3 lg4>

        </v-flex>


    </v-flex>

</template>

<script>
    export default {
        name: "RegSuccess",
        data() {
            return {
                googleURL:'',
                viewNo: 0,
                chartNo:0,
                ptName:'',
                birthDate:'',
                idNo:'',
                fvRv:'',
                zoneName:'',
                viewDate:'',
                apn:'',
                doctorName:'',
                clinicName:'',
                divName:'',
                regNote:'',
                theadWidth:0,
                viewS:"000000",
                viewE:"235900",
                clinicNoteB:'',
                week: ['日', '一', '二', '三', '四', '五', '六'],
            }
        },
        created(){
            this.regNote = '';
            this.viewNo = this.$route.params.viewNo;
            this.chartNo = this.$route.params.chartNo;
            this.ptName = this.$route.params.ptName;
            this.birthDate = this.$route.params.birthDate;
            this.idNo = this.$route.params.idNo;
            this.fvRv = this.$route.params.fvRv=="F"?'初診':'複診';

            this.zoneName = this.$route.query.zoneName;
            this.viewDate = this.$route.query.viewDate;
            // console.log(this.viewDate + "viewDate")
            // console.log(new Date() + "today")
            this.apn = this.transApn(this.$route.query.apn);
            this.doctorName =this.$route.query.doctorName;
            this.clinicName =this.$route.query.clinicName;
            this.divName =this.$route.query.divName==null||this.$route.query.divName==undefined?'':this.$route.query.divName;
            //掛號成功說明文字
            if(this.fvRv=="初診"){
                this.axios_getRegFirstView(this.$route.query.divNo+","+this.$route.query.clinicNo+","+this.$route.query.doctorNo);
            }else {
                this.axios_getRegNote(this.$route.query.divNo+","+this.$route.query.clinicNo+","+this.$route.query.doctorNo)
            }
            let rocDate = parseInt(this.$route.query.viewDate.substring(0,3))+1911
            console.log(rocDate + "rocDate")
            let details = "看診日期:"+this.viewDate+" "+this.apn+"%0A看診號碼:"+this.viewNo+
                "%0A科別/診間:"+this.clinicName+" "+this.divName+"%0A醫師:"+this.doctorName;
            this.axios_getSysSetApnTime(this.$route.query.apn,rocDate,details);
            this.axios_getClinicNoteB(this.$route.query.zone,this.viewDate,this.$route.query.apn,this.$route.query.clinicNo);
            // window.open(googleUrl,'_blank')
            // mdiCalendarMonth
        },
        computed:{
            // $UtilityJs.formatDateTime
            wordDate(){
                let y, m, d;
                let hh, mm, ss;
                if(this.viewDate === undefined || this.viewDate === null||this.viewDate=="[object Window]"||this.viewDate==""||this.viewDate=="null"){
                  return "";
                }else{
                  if(this.viewDate.length==7){
                    y = this.viewDate.substring(0,3);
                    m = this.viewDate.substring(3,5);
                    d = this.viewDate.substring(5,7);
                    if(this.viewDate.startsWith("0")){
                      y = this.viewDate.substring(1,3); //如果民國年小於 100年 ，去除前面的0
                    }
                    if(m.startsWith("0")){
                        console.log(m)
                      m = m.substring(1,2); //如果民國年小於 100年 ，去除前面的0
                    }
                    return y+" 年 "+m+" 月 "+d+" 日 ";

                  }else if(this.viewDate.length==6){
                    hh = this.viewDate.substring(0,2);
                    mm = this.viewDate.substring(2,4);
                    ss = this.viewDate.substring(4,6);
                    return hh+":"+mm+":"+ss;

                  }else if(this.viewDate.length==11){ //例:手術輸入日期 10702261546

                    y = this.viewDate.substring(0,3);
                    m = this.viewDate.substring(3,5);
                    d = this.viewDate.substring(5,7);
                    if(this.viewDate.startsWith("0")){
                      y = this.viewDate.substring(1,3); //如果民國年小於 100年 ，去除前面的0
                    }
                    hh = this.viewDate.substring(7,9);
                    mm = this.viewDate.substring(9,11);
                    return y+"年"+m+"月"+d+"日"+"  "+hh+":"+mm;
                  }else{
                    hh = this.viewDate.substring(0,2);
                    mm = this.viewDate.substring(2,4);
                    return hh+":"+mm;

                  }
                }
            },
        },
        methods:{
            linkGoogle(){
                window.open(this.googleURL,'_blank')
            },
            resizeTable(){
                if(this.$vuetify.breakpoint.smAndDown){
                    this.theadWidth = 'auto';
                }else {
                    this.theadWidth = this.$refs.headerWidth.clientWidth+'px';
                }
            },
            printResult(){
              window.print();
            },
            transApn(apn){
                if(apn.toString()=="1"){
                    return "早上";
                }else if(apn.toString()=='2') {
                    return "下午";
                }else {
                    return "晚上";
                }
            },
            axios_getSysSetApnTime (apn,rocDate,details){ //取得預計看診號時段
                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "iregsetting/datasearch/bygroupidcode/VIEWNO/APN"+apn;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.viewS = response.data.resultSet[0].value1!==undefined&&response.data.resultSet[0].value1!==""?response.data.resultSet[0].value1.toString()+"00":"000000";
                        this.viewE = response.data.resultSet[0].value2!==undefined&&response.data.resultSet[0].value2!==""?response.data.resultSet[0].value2.toString()+"00":"235900";
                    }else{
                        this.viewS = '000000';
                        this.viewE = '235900';
                    }

                    if(this.viewE=="240000"){
                        this.viewE = "235900"
                    }

                    this.googleURL = "https://www.google.com/calendar/event?action=TEMPLATE&trp=true&sf=true&output=xml"+
                        "&dates="+rocDate+""+this.viewDate.substring(3,7)+"T"+this.viewS+"/"+rocDate+""+this.viewDate.substring(3,7)+"T"+this.viewE+
                        "&details="+details+
                        "&location="+ this.zoneName+
                        "&text="+"網路掛號 "+this.apn+" "+this.fvRv+" "+this.viewNo+"號";

                }).catch(error =>  {
                    this.viewS = '000000';
                    this.viewE = '235900';
                    try {
                        console.log(error.response.data.status);
                    } catch(err) {
                        console.log(err.toString())

                    }
                    this.googleURL = "https://www.google.com/calendar/event?action=TEMPLATE&trp=true&sf=true&output=xml"+
                        "&dates="+rocDate+""+this.viewDate.substring(3,7)+"T"+this.viewS+"/"+rocDate+""+this.viewDate.substring(3,7)+"T"+this.viewE+
                        "&details="+details+
                        "&location="+ this.zoneName+
                        "&text="+"網路掛號 "+this.apn+" "+this.fvRv+" "+this.viewNo+"號";

                });

            },
            axios_getRegNote (codeNo){ //掛號說明
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/RESULT/"+codeNo;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.regNote+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                    } catch(err) {
                        console.log(err.response.data.status);
                    }
                });
            },
            //初診掛號說明
            axios_getRegFirstView (codeNo){ //初診掛號說明
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/FIRSTVIEW/"+codeNo;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.regNote+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                        this.axios_getRegNote(codeNo);
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                    } catch(err) {
                        console.log(err.response.data.status);
                    }
                });
            },
            axios_getClinicNoteB (zone,viewDate,apn,clinicNo) { //
                let url = '';
                this.clinicNoteB = '';
                url = this.$store.state.AppSetting.backSrvUrl + "clinicnote/datasearch/primarykeys/" + zone + "/" + viewDate + "/" + apn + "/" + clinicNo + "/B";

                this.$http.get(url).then(response => {
                    if (response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length > 0) {
                        this.clinicNoteB = response.data.resultSet[0].promptNote==null||response.data.resultSet[0].promptNote==''?'':response.data.resultSet[0].promptNote;
                    } else {
                        this.clinicNoteB = '';
                    }


                }).catch(error => {
                    try {
                        console.log(error.response.data.status);
                        this.clinicNoteB = '';
                    } catch (err) {
                        console.log(err)
                        this.clinicNoteB = '';
                    }


                });


            },
        }

    }
</script>

<style scoped>

#weekWord{
    font-size:3.5vw;
}

.timeBox{
    padding-top: 19px;
    padding-bottom: 18px;
}

.dateBox{
    padding-top: 24px;
    padding-bottom: 23px;
}

@media(min-width: 640px){
    #weekWord{
        font-size:1.4rem;
    }
}
@media(min-width: 1263px){
    .timeBox{
        min-width:60px;
    }
}
</style>